import { render, staticRenderFns } from "./HistoryItemsList.vue?vue&type=template&id=5170e2fa&scoped=true"
import script from "./HistoryItemsList.vue?vue&type=script&lang=js"
export * from "./HistoryItemsList.vue?vue&type=script&lang=js"
import style0 from "./HistoryItemsList.vue?vue&type=style&index=0&id=5170e2fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5170e2fa",
  null
  
)

export default component.exports